import iso9001 from "../assets/logoes/iso-9001.png";
import iso10002 from "../assets/logoes/iso-10002.png";
import iso45001 from "../assets/logoes/iso-45001.png";
import iso14001 from '../assets/logoes/iso-14001.png'
import lmwh from '../assets/logoes/LMWH.png'
import logo from "../assets/logoes/sustainable-turism.png";
import ozel_tesis from '../assets/logoes/MQ_ozel_konaklama_tesisi.png'

const certificates = {
  certificates_left:{
    tr: [
    { title: "Kalite yönetim sistemi", src: iso9001 },
    { title: "iş sağlığı ve güvenliği yönetim sistemi", src: iso45001 },
    { title: "Özel Konaklama Tesisi", src: ozel_tesis }
  
  ],

  en: [
    { title: "Quality Management System", src: iso9001 },
    {
      title: "Occupational Health and Safety Management System",
      src: iso45001,
    },
    { title: "special accommodation facility", src: ozel_tesis }
    
  ],
  },
  certificates_middle :{
    tr:[{
      title: "",
      src: lmwh,
    }],
    en:[{
       title: "",
        src: lmwh,
    }]
  },
  certificates_right :{
tr: [
    
    {
      title: "Müşteri Memnuniyeti yönetim sistemi",
      src: iso10002,
    },
    {
      title: "Sürdürülebilir Turizm Onaylı",
      src: logo,
    },
    {
      title: "Çevre Yönetim Sistemi",
      src: iso14001,
    }
  ],

  en: [
    
    {
      title: "Customer Satisfaction and Complaints Handling ",
      src: iso10002,
    },
    {
      title: "Sustainable Turism Verified",
      src: logo,
    },
    {
      title: "Environmental Management System",
      src: iso14001,
    }
  ],
  }
  
};

export default certificates;
